export default __webpack_public_path__ + "static/media/com.46244ea3.jpg";